// extracted by mini-css-extract-plugin
module.exports = {"leasingPrice":"LeasingPrice_leasingPrice__vejL0","priceContent":"LeasingPrice_priceContent__1V1Gn","leasingPriceText":"LeasingPrice_leasingPriceText__DPKXO"};